<template>
  <div class="pt-10 margin-top">
    <HeaderLogo />
    <v-row class="mx-10 px-0 mx-0 justify-center">
      <v-col md="4" sm="12" v-if="!passwordSet && !isError">
        <p align="center">
          Please enter the password you would like to use to log in to StaffHub.
        </p>
        <v-form ref="form" lazy-validation @submit.prevent="setPassword" v-model="isFormValid">
          <v-text-field name="password" v-model="password" label="Create Passsword" class="px-4" :rules="rules.password"
            required :append-icon="isVisiblePassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="isVisiblePassword ? 'text' : 'password'" @click:append="isVisiblePassword = !isVisiblePassword">
          </v-text-field>

          <v-text-field name="repeatPassword" v-model="repeatPassword" label="Confirm Passsword" class="px-4 pt-4"
            :rules="rules.repeatPassword" required :append-icon="isVisibleRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="isVisibleRepeatPassword ? 'text' : 'password'"
            @click:append="isVisibleRepeatPassword = !isVisibleRepeatPassword"></v-text-field>

          <div class="px-5">
            <v-btn type="submit" color="primary" block class="mt-10" :disabled="!isFormValid || isLoading"
              :loading="isLoading">send
            </v-btn>
          </div>
        </v-form>
      </v-col>
      <v-col md="8" sm="12" class="pt-8" v-if="passwordSet">
        <h3 align="center">
          <b>
            Password successfully set. Now you can <a href="javascript:void(0)" @click="$router.push('/login')">login</a>.
          </b>
        </h3>
      </v-col>
      <v-col md="8" sm="12" class="pt-8" v-if="isError">
        <h4 align="center">
          <b>
            {{ errorMessage }}
          </b>
        </h4>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import { ValidationRules } from "@/utils/validation-rules"
import { getRegionName } from "@/utils/functionsRegion";
import HeaderLogo from "@/views/login/HeaderLogo.vue";

export default {
  components: {
    HeaderLogo
  },
  data() {
    return {
      user: null,
      password: null,
      isVisiblePassword: false,
      isVisibleRepeatPassword: false,
      isFormValid: true,
      isLoading: false,
      isError: false,
      passwordSet: false,
      repeatPassword: "",
      linkErrorMessage: "The link has already been used",
      invalidToken: "The link is invalid",
      passwordErrorMessage: "Unable to set password",
      errorMessage: ""
    };
  },
  computed: {
    rules() {
      return {
        password: [
          ValidationRules.required,
          ValidationRules.min(6),
          ValidationRules.number,
          ValidationRules.capitalLetter,
          ValidationRules.lowerLetter,
          ValidationRules.symbol
        ],
        repeatPassword: [
          ValidationRules.required,
          ValidationRules.min(6),
          ValidationRules.isEqualTo(this.password)
        ]
      };
    }
  },
  mounted() {
    firebase
      .firestore()
      .collection("users")
      .where("setPasswordToken", "==", this.$route.params.token).get()
      .then((snap) => {
        if (snap.empty) {
          this.setError(true, this.linkErrorMessage)
        }
        else if (snap.docs.length == 1) {
          this.user = snap.docs[0].data();
          this.user.id = snap.docs[0].id;
        }
        else if (snap.docs.length > 1) {
          this.setError(true, this.invalidToken)
        }
      })
  },
  methods: {
    setError(state, message) {
      if (state) {
        this.isError = true;
        this.errorMessage = message;
      }
      else {
        this.isError = false;
        this.errorMessage = '';
      }
    },
    setPassword() {
      this.isFormValid = this.$refs.form.validate();

      if (!this.isFormValid) return;

      this.isLoading = true;

      firebase.app().functions(getRegionName())
        .httpsCallable("staff-createAuthUser")({
          staffUserId: this.user.id,
          password: this.password
        })
        .then(snap => {
          firebase
            .firestore()
            .collection('users')
            .doc(this.user.id)
            .update({ setPasswordToken: null, passwordSetDateTime: firebase.firestore.Timestamp.now() }).then(() => {
              this.passwordSet = true;
            })
        }).catch(() => {
          console.log("Error setting password");
          this.setError(true, this.passwordErrorMessage);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};

</script>

<style lang="scss" scoped>
.margin-top{
  margin-top: 40vh;
  transform: translateY(-50%); 
}

@media (max-height: 520px) {
  .margin-top { margin-top: 16px; transform: none; }
}
</style>